import { Badge, cn } from '../../ui';
import type { StatusLight } from './status';

/** A green or grey light with its word, then the muted detail beside it. */
export function StatusBadge({ status }: { status: StatusLight }) {
  return (
    <span className="sk:inline-flex sk:flex-wrap sk:items-center sk:gap-2">
      <Badge tone={status.isOnline ? 'success' : 'neutral'}>
        <span
          aria-hidden
          className={cn(
            'sk:size-2 sk:rounded-full',
            status.isOnline ? 'sk:bg-success' : 'sk:bg-fg-tertiary',
          )}
        />
        {status.label}
      </Badge>
      {status.detail ? (
        <span className="sk:text-dense sk:text-fg-tertiary">
          {status.detail}
        </span>
      ) : null}
    </span>
  );
}
